module.exports = __webpack_public_path__ + "img/Imagen-fondo-g.63a12761.svg";